<template lang="pug">
    transition(name="loader", appear, mode="out-in")
      slot
      .loader
        span.loader__element
        span.loader__element
        span.loader__element
</template>

<script>
export default {
    name: "Loader",
};
</script>

<style lang="scss">
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
:root {
  --size: 5px;
}

.loader {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0; 
  left: 0;
  display: flex;
  align-items: center;
  align-content: center; 
  justify-content: center;  
  z-index: 100000;
  & + * {
    filter: blur(calc(var(--size)*.8));
  }
    &__element {
        border-radius: 100%;
        border: var(--size) solid var(--registration-button-teal);
        margin: calc(var(--size)*2);
        &:nth-child(1) {
            animation: preloader .6s ease-in-out alternate infinite;
        }
        &:nth-child(2) {
            animation: preloader .6s ease-in-out alternate .2s infinite;
        }
        &:nth-child(3) {
            animation: preloader .6s ease-in-out alternate .4s infinite;
        }
    }
}

@keyframes preloader {
  100% { transform: scale(2); }
}
</style>